import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilterRemove = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "nofilter",
	"data-name": "nofilter",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-6 -6 36 36",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("polygon", {
			className: "plan2plate-icon filled",
			points: "19.415,22 24,17.414 28.587,22 30,20.587 25.414,16 30,11.414 28.586,10 24,14.586 19.414,10 18,11.414 22.586,16 18,20.585 ",
			id: "polygon1",
			transform: "translate(-4,-4)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "plan2plate-icon filled",
			d: "m 0,0 a 2,2 0 0 0 -2,2 v 3.1709 a 2,2 0 0 0 0.5859,1.4145 L 6,14 v 8 a 2,2 0 0 0 2,2 h 4 a 2,2 0 0 0 2,-2 v -2 h -2 v 2 H 8 V 13.1709 L 7.4141,12.5854 0,5.1709 V 2 h 20 v 2 h 2 V 2 A 2,2 0 0 0 20,0 Z",
			id: "path1"
		})
	]
});
const ForwardRef = forwardRef(SvgFilterRemove);
export default ForwardRef;
